export default () => ({
  actionsRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'right',
    margin: '1rem auto',
  },
});
